module.exports = __webpack_public_path__ + "static/media/3b.58d4115c.svg";